import { combineReducers } from 'redux';
import { menuReducer, MenuState } from './menu/reducers';

export interface LayoutState {
  menu: MenuState;
}

export const layoutReducer = combineReducers<LayoutState>({
  menu: menuReducer
});
